import type { ColDef } from "ag-grid-community";

export const getColumnDefinitions = (
  _onToggleStatus: (id: string, currentStatus: string) => void,
  _loadingTests: Set<string>
): ColDef[] => [
  {
    headerName: "Test ID",
    field: "id",
    filter: "agTextColumnFilter",
    sortable: true,
    resizable: true,
    minWidth: 120,
    maxWidth: 200,
    valueFormatter: (params: any) => {
      return params.value || "No ID";
    }
  },
  {
    headerName: "Test Name",
    field: "name",
    filter: "agTextColumnFilter",
    sortable: true,
    resizable: true,
    minWidth: 200,
    maxWidth: 350,
    valueFormatter: (params: any) => {
      if (!params.value) {
        return "No Test Name";
      }
      const activeIndicator = params.data.isActive ? " ✓" : "";
      return params.value + activeIndicator;
    }
  },
  {
    headerName: "Status",
    field: "status",
    filter: "agSetColumnFilter",
    sortable: true,
    resizable: true,
    minWidth: 120,
    maxWidth: 180,
    valueFormatter: (params: any) => {
      if (!params.value) {
        return "No Status";
      }
      const statusText: { [key: string]: string } = {
        "active": "Active",
        "paused": "Paused",
        "completed": "Completed",
        "draft": "Draft"
      };
      return statusText[params.value] || params.value;
    }
  },
  {
    headerName: "Variants",
    field: "variants",
    filter: "agNumberColumnFilter",
    sortable: true,
    resizable: true,
    minWidth: 100,
    maxWidth: 150,
    valueFormatter: (params: any) => {
      const count = params.value || 0;
      return `${count} variants`;
    }
  },
  {
    headerName: "Traffic Split",
    field: "trafficSplit",
    filter: false,
    sortable: false,
    resizable: true,
    minWidth: 200,
    maxWidth: 300,
    valueFormatter: (params: any) => {
      if (!params.value) {
        return "No split configured";
      }
      // Display traffic split percentages
      return params.value.map((split: any) => `${split.name}: ${split.percentage}%`).join(", ");
    }
  },
  {
    headerName: "Conversion Rate",
    field: "conversionRate",
    filter: "agNumberColumnFilter",
    sortable: true,
    resizable: true,
    minWidth: 140,
    maxWidth: 200,
    valueFormatter: (params: any) => {
      const rate = params.value || 0;
      const isWinner = params.data.isWinner;
      const winnerIndicator = isWinner ? " 🏆" : "";
      return `${rate.toFixed(2)}%${winnerIndicator}`;
    }
  },
  {
    headerName: "Total Visitors",
    field: "totalVisitors",
    filter: "agNumberColumnFilter",
    sortable: true,
    resizable: true,
    minWidth: 130,
    maxWidth: 180,
    valueFormatter: (params) => {
      if (!params.value) return "0";
      return params.value.toLocaleString();
    }
  },
  {
    headerName: "Created",
    field: "created",
    filter: "agDateColumnFilter",
    sortable: true,
    resizable: true,
    minWidth: 140,
    maxWidth: 200,
    valueFormatter: (params) => {
      if (!params.value) return "N/A";
      return (
        new Date(params.value).toLocaleDateString() +
        " " +
        new Date(params.value).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        })
      );
    }
  },
  {
    headerName: "Updated",
    field: "updated",
    filter: "agDateColumnFilter",
    sortable: true,
    resizable: true,
    minWidth: 140,
    maxWidth: 200,
    valueFormatter: (params) => {
      if (!params.value) return "Never";
      return (
        new Date(params.value).toLocaleDateString() +
        " " +
        new Date(params.value).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        })
      );
    }
  },
  {
    headerName: "Active",
    field: "actions",
    filter: false,
    sortable: false,
    resizable: false,
    minWidth: 80,
    maxWidth: 100,
    pinned: "right",
    valueFormatter: (params: any) => {
      const status = params.data.status;
      const isActive = status === "active";
      const isCompleted = status === "completed";
      
      if (isCompleted) {
        return "Completed";
      }
      
      return isActive ? "Active" : "Inactive";
    }
  }
];

export const defaultColDef = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 100,
  suppressSizeToFit: true,
  autoHeaderHeight: true
};
